import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { extendObservable, intercept } from 'mobx'
import styled, { keyframes } from 'styled-components'
import PendingIndicatorIcon from '@/assets/images/pending-indicator-black.svg'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import AnnounceItemOnStack from '@/Components/CommandHost/AnnounceItemOnStack'
import PlayItemOnStack from '@/Components/CommandHost/PlayItemOnStack'
import { vhToPxNum } from '@/utils'
import _ from 'lodash'

@inject('PrePlayStore', 'PlayStore', 'GameStore', 'CommonStore')
@observer
export default class StackPanel extends Component {
  constructor(props) {
    super(props)
    extendObservable(this, {
      isStackScrolling: false,
    })
    this.preplaySequences = null
    this.state = {
      isPmetadataUpdated: false,
      isSelectionModeChanged: false,
      destinationItem: null,
      checkedSModeItems: [],
    }

    this.disposeSelectionMode = intercept(
      this.props.CommonStore,
      'selectionMode',
      change => {
        if (change && change.newValue) {
          if (
            !change.newValue.sModePlays ||
            change.newValue.sModePlays.length === 0
          ) {
            this.setState({ checkedSModeItems: [], destinationItem: null })
          }
          this.setState({ isSelectionModeChanged: change.newValue })
        }
      }
    )
  }

  onDragStart = () => {
    this.preplaySequences = this.props.PrePlayStore.preplayItems.map(
      _p => _p.sequence
    )
  }

  onDragEnd = result => {
    const { source, destination, draggableId } = result

    if (
      !destination ||
      !this.props.PrePlayStore.preplayItems ||
      (source.droppableId === destination.droppableId &&
        source.index === destination.index)
    )
      return

    const newItem = this.props.PrePlayStore.preplayItems[source.index]
    //console.log('1111', this.props.PrePlayStore.preplayItems.map(_p => _p.sequence)) //-tmp
    this.props.PrePlayStore.preplayItems.splice(source.index, 1)
    this.props.PrePlayStore.preplayItems.splice(destination.index, 0, newItem)
    //console.log('2222', source.index, destination.index, this.props.PrePlayStore.preplayItems.map(_p => _p.sequence)) //-tmp

    let arr = []
    for (let _i = 0; _i < this.props.PrePlayStore.preplayItems.length; ++_i) {
      if (
        this.preplaySequences[_i] ===
        this.props.PrePlayStore.preplayItems[_i].sequence
      )
        continue
      this.props.PrePlayStore.preplayItems[_i].sequence = this.preplaySequences[
        _i
      ]
      arr.push({
        id: this.props.PrePlayStore.preplayItems[_i].gamePlayId,
        sequence: this.preplaySequences[_i],
      })
    }

    if (arr.length) {
      this.props.PlayStore.movePlay({
        gameId: this.props.GameStore.gameId,
        plays: JSON.stringify(arr),
        //sourceIndex: source.index,
        //destinationIndex: destination.index,
      })
    }
    this.preplaySequences = null
  }

  handleRemoveFromStack(args) {
    this.props.GameStore.removePlay(args)
  }

  handleGoX(item) {
    this.props.PlayStore.gamesGoPlay(item, next => {
      this.props.PrePlayStore.setAddToStackItem(null)
    })
  }

  handleGo(item) {
    this.props.GameStore.syncRequest({
      processName: 'ADD_PLAY',
      gameId: this.props.GameStore.gameId,
      syncGuid: 'abc123',
      isReuse: true,
    })
    this.props.GameStore.goPlay(item)
  }

  // handleGamesUpdate(item) {
  //   setTimeout(() => {
  //     this.props.PlayStore.gamesUpdate(item).then(response => {
  //       console.log('ITEM - UPDATED', response)
  //     })
  //   }, 0)
  // }

  handleGamesUpdate(item) {
    this.props.GameStore.updatePlay(item)
  }

  handleGamesUpdatePreset(args) {
    this.props.PlayStore.gamesUpdatePreset(args)
  }

  toggleStackScrolling() {
    setTimeout(() => {
      const stackwrapper = document.getElementById('stack-wrapper')
      if (stackwrapper) {
        if (stackwrapper.offsetHeight >= vhToPxNum(stackScrollHeight)) {
          this.isStackScrolling = true
        } else {
          this.isStackScrolling = false
        }
      }
    }, 100)
  }

  handlePlayCheckSMode(item) {
    let { checkedSModeItems = [] } = this.state
    if (!item) return
    if (
      checkedSModeItems.findIndex(
        checkedItem => checkedItem.gamePlayId === item.gamePlayId
      ) === -1
    ) {
      checkedSModeItems.push(item)
    } else {
      _.remove(
        checkedSModeItems,
        checkedItem => checkedItem.gamePlayId === item.gamePlayId
      )
    }
    this.setState({ checkedSModeItems: checkedSModeItems || [] })
    this.props.CommonStore.setSModePlays(checkedSModeItems)
  }

  isPlayChecked(item) {
    return (
      (this.state.checkedSModeItems || []).findIndex(
        checkedItem => checkedItem.gamePlayId === item.gamePlayId
      ) !== -1
    )
  }

  handleDestinationSelection(item) {
    if (!item) return
    this.setState({ destinationItem: item })
    this.props.CommonStore.setDestinationItem(item)
  }

  componentWillUnmount() {
    this.disposeSelectionMode()
  }

  render() {
    this.toggleStackScrolling()
    let { preplayItems } = this.props.PrePlayStore

    return (
      <StackContainer
        id="all_stack_container_to_go"
        isScrolling={this.isStackScrolling}
      >
        <LoadingComp />
        <StackContainerScrolling
          isScrolling={this.isStackScrolling}
          isSelectionModeOn={
            this.props.CommonStore.selectionMode &&
            this.props.CommonStore.selectionMode.isSMode
          }
        >
          {preplayItems && preplayItems.length > 0 ? (
            <DragDropContext
              onDragStart={this.onDragStart}
              onDragEnd={this.onDragEnd}
              onDragUpdate={this.onDragUpdate}
            >
              <Droppable droppableId={'play-stack-1'}>
                {provided => (
                  <PrePlayStackWrapper
                    innerRef={provided.innerRef}
                    {...provided.droppableProps}
                    id="stack-wrapper"
                  >
                    {preplayItems.map((item, idx) => {
                      if ('announce' === item.type.toLowerCase()) {
                        const [header = {}, middle = {}] =
                          (item && item.announcements) || []
                        return (
                          <AnnounceItemOnStack
                            key={`stack-${item.id || item.sequence}`}
                            item={item}
                            index={idx}
                            remove={this.handleRemoveFromStack.bind(this)}
                            go={this.handleGo.bind(this)}
                            currentStack={'stack'}
                            gamesUpdate={this.handleGamesUpdate.bind(this)}
                            zIndexIndex={idx - preplayItems.length}
                            selectionMode={this.props.CommonStore.selectionMode}
                            handlePlayCheckSMode={this.handlePlayCheckSMode.bind(
                              this
                            )}
                            isChecked={this.isPlayChecked(item)}
                            handleDestinationSelection={this.handleDestinationSelection.bind(
                              this
                            )}
                            isDestination={
                              (this.state.destinationItem || {}).gamePlayId ===
                              item.gamePlayId
                            }
                          />
                        )
                      }
                      var choices = ''
                      choices =
                        (item &&
                          item.choices &&
                          item.choices
                            .map(choice => {
                              return choice.value
                            })
                            .join()) ||
                        ''
                      const isEditingindex = this.props.PrePlayStore.liveEditingItems.findIndex(
                        liveEditItem => {
                          return liveEditItem.gamePlayId === item.gamePlayId
                        }
                      )
                      let liveEditingItem = null
                      if (isEditingindex !== -1) {
                        liveEditingItem = this.props.PrePlayStore
                          .liveEditingItems[isEditingindex]
                      }

                      return (
                        <PlayItemOnStack
                          key={`stack-play-${item.id || item.sequence}`}
                          item={JSON.parse(JSON.stringify(item))}
                          liveEditingItem={liveEditingItem}
                          // index={
                          //   idx - preplayItems.length
                          // }
                          index={idx}
                          zIndexIndex={idx - preplayItems.length}
                          remove={this.handleRemoveFromStack.bind(this)}
                          go={this.handleGo.bind(this)}
                          headerSelectedTeam={this.selectedTeam}
                          gamesUpdate={this.handleGamesUpdate.bind(this)}
                          gamesUpdatePreset={this.handleGamesUpdatePreset.bind(
                            this
                          )}
                          selectionMode={this.props.CommonStore.selectionMode}
                          handlePlayCheckSMode={this.handlePlayCheckSMode.bind(
                            this
                          )}
                          isChecked={this.isPlayChecked(item)}
                          handleDestinationSelection={this.handleDestinationSelection.bind(
                            this
                          )}
                          isDestination={
                            (this.state.destinationItem || {}).gamePlayId ===
                            item.gamePlayId
                          }
                        />
                      )
                    })}
                    {provided.placeholder}
                    {/* //split attempt
                     this.props.PrePlayStore.preplayItemsBuffer.length ?
                      (setTimeout(() => this.props.PrePlayStore.setPrePlayItems(), 1000
                      )) :
                      (
                        null
                      )
                      */}
                  </PrePlayStackWrapper>
                )}
              </Droppable>
            </DragDropContext>
          ) : (
            <PrePlayStackWrapperEmpty />
          )}
        </StackContainerScrolling>
      </StackContainer>
    )
  }
}

@inject('PrePlayStore')
@observer
class LoadingComp extends Component {
  render() {
    if (this.props.PrePlayStore.isAddingStack) {
      return <PendingIndicator />
    } else {
      return null
    }
  }
}

const h = 5
const stackScrollHeight = 68
const maxStackScrollHeight = 87

const StackContainer = styled.div`
  width: 100%;
  background-color: #eaeaea;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 4;
  padding-right: ${props => (props.isScrolling ? 0 : 0.6)}%;
`

const StackContainerScrolling = styled.div`
  position: relative;
  width: 100%;
  max-height: ${props =>
    props.isSelectionModeOn ? maxStackScrollHeight : stackScrollHeight}vh;
  background-color: #eaeaea;
  overflow-y: ${props => (props.isScrolling ? 'scroll' : 'none')};
  ms-overflow-style: ${props =>
    props.isScrolling ? '-ms-autohiding-scrollbar' : 'none'};

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0.3vh rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
    border-radius: ${props => 1}vh;
  }
  &::-webkit-scrollbar {
    width: ${props => 1.2}vh;
    background-color: #f5f5f5;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 0, 0, 0.6);
    &:hover {
      background-color: rgba(255, 0, 0, 1);
    }
    border-radius: ${props => 1}vh;
  }
`

const PrePlayStackWrapper = styled.div`
  width: inherit;
  display: flex;
  flex-direction: column;
`

const PrePlayStackWrapperEmpty = styled.div`
  width: 100%;
  height: ${props => h}vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainlight;
  letter-spacing: ${props => 0.2}vh;
  font-size: ${props => 3}vh;
  color: #808285;
  &:after {
    content: 'DRAGGABLE STACK';
  }
`

const PendingIndicator = styled.div`
  width: ${props => h}vh;
  height: ${props => h}vh;
  display: flex;
  align-items: center;
  &:after {
    content: '';
    display: block;
    width: ${props => h}vh;
    height: ${props => h}vh;
    background-image: url(${props => PendingIndicatorIcon});
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: center;
    animation: ${props => pendingRotate} 1s linear infinite;
    transform-origin: center center;
  }
`

const pendingRotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`

const LoadingText = styled.span`
  font-family: pamainregular;
  font-size: ${props => 2.5}vh;
  color: #000000;
  letter-spacing: ${props => 0.2}vh;
  text-transform: uppercase;
  padding-left: ${props => 1}vh;
  &:after {
    content: '.';
    animation: ${props => dots} 1s steps(5, end) infinite;
  }
`

const dots = keyframes`
 0%, 20% {
    color: rgba(255,255,255,0);
    text-shadow:
      .25em 0 0 rgba(255,255,255,0);,
      .5em 0 0 rgba(255,255,255,0);;}
  40% {
    color: black;
    text-shadow:
      .25em 0 0 rgba(255,255,255,0);,
      .5em 0 0 rgba(255,255,255,0);;}
  60% {
    text-shadow:
      .25em 0 0 black,
      .5em 0 0 rgba(255,255,255,0);;}
  80%, 100% {
    text-shadow:
      .25em 0 0 black,
      .5em 0 0 black;}}
`



// WEBPACK FOOTER //
// src/Components/CommandHost/StackPanel.js